export default __webpack_public_path__ + "static/media/image-icon.d4059fe0.svg";